module.exports = __webpack_public_path__ + "img/file.3db64193.svg";